import React from 'react';
import { Box, Button, Flex, Text, Spinner, Badge } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import { useData } from '../../../data';
import Header from '../../../components/header/Header';

const FunderDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data, isLoading } = useData(
    id ? `funders/${id}` : '',
    0,
    {},
    1,
    !!id,
  );
  const funder = data?.data?.funder || data?.funder || data?.data || null;

  return (
    <Box>
      <Header title="Funder details" />
      <Box className="p-4 bg-[#f0f0f0]">
        <Box className="bg-white rounded-xl p-6 shadow-sm">
          <Button mb={6} onClick={() => navigate('/funders')}>
            Back to Funders
          </Button>

          {isLoading ? (
            <Flex justifyContent="center" alignItems="center" minH="280px">
              <Spinner size="lg" />
            </Flex>
          ) : funder ? (
            <Box>
              <Flex
                justifyContent="space-between"
                alignItems="flex-start"
                flexWrap="wrap"
                gap={4}
              >
                <Box>
                  <Text fontSize="3xl" fontWeight="700" mb={2}>
                    {funder.name}
                  </Text>
                  <Text color="gray.600" fontSize="md">
                    {funder.type || 'N/A'} · {funder.hq_country || 'Global'}
                  </Text>
                </Box>
                <Badge
                  colorScheme={funder.status === 'active' ? 'green' : 'gray'}
                >
                  {funder.status || 'Unknown'}
                </Badge>
              </Flex>

              <Box mt={6}>
                <Text fontWeight="700" mb={2}>
                  Description
                </Text>
                <Text color="gray.700" whiteSpace="pre-wrap">
                  {funder.description || 'No description provided.'}
                </Text>
              </Box>

              <Flex flexDir={{ base: 'column', md: 'row' }} gap={6} mt={6}>
                <Box flex={1} bg="#F7FAFC" rounded="lg" p={5}>
                  <Text fontWeight="700" mb={3}>
                    Contact
                  </Text>
                  <Text mb={2}>Name: {funder.contact_name || 'N/A'}</Text>
                  <Text mb={2}>Email: {funder.contact_email || 'N/A'}</Text>
                  <Text mb={2}>Website: {funder.website_url || 'N/A'}</Text>
                  <Text mb={2}>
                    Application: {funder.application_url || 'N/A'}
                  </Text>
                </Box>
                <Box flex={1} bg="#F7FAFC" rounded="lg" p={5}>
                  <Text fontWeight="700" mb={3}>
                    Funding details
                  </Text>
                  <Text mb={2}>
                    Stages: {funder.stage_focus?.join(', ') || 'N/A'}
                  </Text>
                  <Text mb={2}>
                    Sectors: {funder.sector_focus?.join(', ') || 'N/A'}
                  </Text>
                  <Text mb={2}>
                    Geographies: {funder.geography_focus?.join(', ') || 'N/A'}
                  </Text>
                  <Text mb={2}>
                    Cheque range: {funder.cheque_min || 'N/A'} –{' '}
                    {funder.cheque_max || 'N/A'}
                  </Text>
                </Box>
              </Flex>
            </Box>
          ) : (
            <Text color="gray.600">Unable to load funder details.</Text>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default FunderDetail;
